




























































































import Vue from "vue";
import dayjs from "dayjs";
import eventBus from "@/services/eventBus";
import api from "../services/api";
import { PayrollImportResult } from "../models/PayrollImport";
import { t } from "@/plugins/i18n";

// K2D bérfeladás importok portja egy közös nézeten:
// - "Bérfeladás TXT-ből" (m_dun_ber -> ue_dun_ber)
// - "Bérfeladás XLS-ből" (m_bal_import -> m_import -> w_popup_import, élő formátum)
// A feldolgozó ág a fájl kiterjesztése szerint dől el. All-or-nothing: hibás fájlnál semmi
// nem kerül könyvelésre, az összes hiba listázva.

interface Data {
  file: File | null;
  result: PayrollImportResult | null;
}

interface Methods {
  importFile(): Promise<void>;
  formatDate(d: string): string;
  formatTotal(t: number): string;
}

export default Vue.extend<Data, Methods, {}, {}>({
  name: "PayrollImportView",

  data(): Data {
    return {
      file: null,
      result: null,
    };
  },

  methods: {
    formatDate(d: string): string {
      return d ? dayjs(d).format("YYYY.MM.DD.") : "";
    },

    formatTotal(t: number): string {
      return (t ?? 0).toLocaleString("hu-HU");
    },

    async importFile() {
      if (!this.file) return;
      this.result = null;
      const isExcel = /\.xlsx?$/i.test(this.file.name);
      eventBus.$emit("busy-message", true);
      try {
        this.result = isExcel
          ? await api.ImportPayrollXls(this.file)
          : await api.ImportPayrollTxt(this.file);
        if (this.result.success) {
          eventBus.$emit("success", this.result.message);
          this.file = null;
        } else {
          eventBus.$emit("error", this.result.message);
        }
      } catch (e) {
        console.error(e);
        eventBus.$emit("error", t("GeneralLedger_AFeladasSikertelen"));
      } finally {
        eventBus.$emit("busy-message", false);
      }
    },
  },
});
